 @if ( ceoiPolicyFlag) {
<a #topOfPage id="topOfPage"></a>
<div class="page-content" page-content >
    <img class="centerImage" alt="sick-computer-" src="{{alertLogoUrl}}"/>
      <br>
          <div>
            <prism-ui-heading
              slot="instructions-ceoi-header"
              key-id="instructions-ceoi-header"
              font-size="lg"
              font-weight="regular"
              is-uppercase="false"
              variant="default"
              >
              {{ceoiPolicyFlagContent.title}}
            </prism-ui-heading>
            <prism-ui-copy
              key-id="instructions-ceoi-body"
              >
              <p class="center">{{ceoiPolicyFlagContent.body}}</p>
            </prism-ui-copy>
          </div>
      
 <!-- <ng-container>
      <div class="topPadding bottomPadding">
        <prism-ui-container
          is-compact="false"
          key-id="notification"
          has-shadow="false"
          variant="neutral"
          has-no-border-radius="false"
          >
          <prism-ui-copy
            key-id="notification"
            >
            <h2>{{ceoiPolicyFlagContent.title}}</h2>
            <p>{{ceoiPolicyFlagContent.body}}</p>
          </prism-ui-copy>
        </prism-ui-container>
      </div>
    </ng-container> -->
    </div>
 }
 @else {
<prism-ui-page-content
    [illustrationUrl]="pageIllustrationUrl"
    [illustrationTop]="false">
    <div class="page-content" page-content>
        <prism-ui-heading
            slot="invalid-policy-number-header"
            key-id="invalid-policy-number-header"
            font-size="lg" 
            font-weight="regular" 
            is-uppercase="false"
            variant="default"
        >
        {{invalidCustomUrlContent.title}}
        </prism-ui-heading>
        <prism-ui-copy>
            <p [innerHTML]="invalidCustomUrlContent.body"></p>
        </prism-ui-copy>
    </div>
</prism-ui-page-content>
 }